import styled from 'styled-components'

export const ComplaintsSelectContainer = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const SelectedOptionsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 5px 10px;
`
